import { createContext, useContext } from "react";

export type THeaderDrawerContextProps = {
  visible: boolean
}
export const HeaderDrawerContext = createContext<THeaderDrawerContextProps>({ visible: false });
export const useHeaderDrawerContext = (): THeaderDrawerContextProps => useContext(HeaderDrawerContext); 
